var React = require('react');

function MobileLinkIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"arrow-up-right-from-square-light_1_","data-name":"arrow-up-right-from-square-light (1)","d":"M14.678,0a.7.7,0,0,0,0,1.4h5.3L9.292,12.087a.7.7,0,1,0,.987.987L20.968,2.385v5.3a.7.7,0,0,0,1.4,0V.7a.7.7,0,0,0-.7-.7ZM2.8,2.8A2.8,2.8,0,0,0,0,5.592V19.57a2.8,2.8,0,0,0,2.8,2.8H16.775a2.8,2.8,0,0,0,2.8-2.8V13.28a.7.7,0,1,0-1.4,0v6.29a1.4,1.4,0,0,1-1.4,1.4H2.8a1.4,1.4,0,0,1-1.4-1.4V5.592a1.4,1.4,0,0,1,1.4-1.4h6.29a.7.7,0,0,0,0-1.4Z","fill":"currentColor"}));
}

MobileLinkIcon.defaultProps = {"width":"22.366","height":"22.366","viewBox":"0 0 22.366 22.366"};

module.exports = MobileLinkIcon;

MobileLinkIcon.default = MobileLinkIcon;
